import React from "react";
import { Button, Control, Field, Select } from "@allxsmith/bestax-bulma";

export default function VehicleTrackerTypePicker({dataFresh, updateValue, tracker, types, onSave, editable, setEditable, inLineEdit=true}){


    return (
      <Field className={'has-addons'}>
        <Control>
          <Select
            name={"type"}
            value={tracker.type ? tracker.type.id : -1}
            onChange={(e) => updateValue(e)}
            disabled={!editable}
          >
            <option key={-1} value={"BLANK"}></option>
            {types.results.map(type => (
              <option key={type.id} value={type.id}>
                  {type.name}
              </option>
            ))}
          </Select>
        </Control>

        {inLineEdit && (editable ? (
              <Control>
                <Button
                    className="small-row-white"
                    color="success"
                    onClick={onSave}
                >
                  S
                </Button>
              </Control>
          ) : (
              <Control>
                <Button
                    className="small-row-black"
                    onClick={() => setEditable(!editable)}
                >
                  E
                </Button>
              </Control>
          ))}
      </Field>
    );

}